import React from "react";
import { Grid } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import Skeleton from "@material-ui/lab/Skeleton";
import useStyles from "./styles";

const SkeletonContent = () => {
  const classes = useStyles();
  return (
    <Grid container>
      {[0, 1, 2, 3, 4].map((i) => (
        <SkeletonRow key={i} classes={classes} />
      ))}
    </Grid>
  );
};

const SkeletonRow = ({ classes }) => {
  return (
    <Grid container justify="space-around" alignItems="center" wrap="nowrap" className={classes.categoryBox}>
      <Grid item>
        <Skeleton>
          <MenuIcon />
        </Skeleton>
      </Grid>
      <Grid item xs={4}>
        <Skeleton animation="wave" variant="text" height={24} />
      </Grid>
      <Grid item xs={3}>
        <Skeleton animation="wave" variant="text" />
      </Grid>
    </Grid>
  );
};

export default SkeletonContent;
